import { IMeshColumnData, IMeshRowData } from "@pageBuilder/typings";
import { ISiblingsColumnsResult, ResizeDirection } from "./mesh-resizer";

export class MeshUtil {

    public static getSiblingColumnByDirection(widgetColumn: HTMLElement, direction: ResizeDirection): HTMLElement | null {
        let sibling: HTMLElement; 
        
        if (direction === "Left" || direction === "Left-Down") {
            sibling = widgetColumn.previousElementSibling as HTMLElement;
        } else {
            sibling = widgetColumn.nextElementSibling as HTMLElement;
        }

        if (sibling?.hasAttribute("data-mesh-col")) {
            return sibling;
        }

        return null;
    }

    public static getSiblingColumnsByDirection(column: HTMLElement, direction: ResizeDirection): ISiblingsColumnsResult {
        const emptyColumns: HTMLElement[] = [];
        const notEmptyColumns: HTMLElement[] = [];

        let siblingColumn = MeshUtil.getSiblingColumnByDirection(column, direction);
        if (!siblingColumn) {
            return { emptyColumns: [], notEmptyColumns: [] };
        }

        do {
            if (MeshUtil.isEmptyColumn(siblingColumn)) {
                emptyColumns.push(siblingColumn);
            } else {
                const columnSize = MeshUtil.getColumnSize(siblingColumn);
                if (columnSize > 1) {
                    notEmptyColumns.push(siblingColumn);
                }
            }

            siblingColumn = MeshUtil.getSiblingColumnByDirection(siblingColumn, direction);
        } while (siblingColumn !== null);

        return { emptyColumns: emptyColumns, notEmptyColumns: notEmptyColumns };
    }

    public static isWidget(element: HTMLElement): boolean {
        return element.hasAttribute("data-widget");
    }

    public static isColumn(element: HTMLElement): boolean {
        return element.hasAttribute("data-mesh-col");
    }

    public static isRow(element: HTMLElement): boolean {
        return element.hasAttribute("data-mesh-row");
    }

    public static isEmptyColumn(column: HTMLElement): boolean {
        if (!MeshUtil.isColumn(column)) {
            return false;
        }

        const widgets = column.querySelectorAll("[data-widget]");
        return !widgets || widgets.length <= 0;
    }

    public static isEmptyColumnData(columnData: IMeshColumnData): boolean {
        return (columnData.widgets?.length ?? 0) <= 0;
    }

    public static isEmptyRowData(rowData: IMeshRowData): boolean {
        return rowData.columns!.every(columnData => MeshUtil.isEmptyColumnData(columnData));
    }

    public static isEmptyRow(row: HTMLElement): boolean {
        if (!MeshUtil.isRow(row)) {
            return false;
        }

        const columns = row.querySelectorAll("[data-mesh-col]");

        if (!columns || columns.length <= 0) {
            return true;
        }

        let result = true;

        columns.forEach(column => {
            if (!MeshUtil.isEmptyColumn(column as HTMLElement)) {
                result = false;
                return;
            }
        });

        return result;
    }

    public static getColumnSize(column: HTMLElement): number {
        return Number.parseInt(column.getAttribute("data-col-size") ?? "");
    }

}
